import { useMemo } from 'react';
import { useQuery } from 'react-fetching-library';
// Deep imports: the account barrel reaches into shared UI and redux.
import { fetchSurveysAction } from '@entities/account/api/fetchSurveysAction';
import { fetchResourcesAction } from '@entities/account/api/fetchResourcesAction';
import { buildAssetTitleIndex } from '../lib/assetTitles';

/**
 * Catalogue titles for the steps whose name is only the item's key
 * (seeded templates) - see assetTitleOf, which shows the author's own
 * step name whenever there is one.
 *
 * Both catalogues are small and fetched only while `enabled`; until
 * they arrive the index is empty and callers fall back to the step's
 * own name.
 */
export const useAssetCatalog = (enabled = true) => {
  const { payload: surveysPayload } = useQuery(fetchSurveysAction(), enabled);
  const { payload: resourcesPayload } = useQuery(fetchResourcesAction(), enabled);
  return useMemo(
    () => ({ titles: buildAssetTitleIndex(surveysPayload?.result, resourcesPayload) }),
    [surveysPayload, resourcesPayload]
  );
};
